export default __webpack_public_path__ + "static/media/25.f0507257.png";